import compact from 'lodash/compact'
import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

interface Config {
  model_ref: string
  instance_id?: string
}

export interface ICustomFieldValue {
  [key: string]: any
}

class CustomFieldValue extends Model<ICustomFieldValue> {
  config: Config | null | undefined

  constructor(data: ICustomFieldValue, config?: Config) {
    super(data)
    makeObservable(this, {
      isInstalled: computed,
    })
    this.config = config
  }

  // FIXME: model should not be coupled to collections
  url() {
    const config = this.config

    if (config && config.instance_id) {
      if (!this.attributes.id) {
        return `/custom_fields/values/${config.model_ref}/${config.instance_id}`
      }

      return `/custom_fields/values/${config.model_ref}/${config.instance_id}/${this.attributes.id}`
    }

    if (this.collection) {
      return compact([(this.collection as any).dynamicPath, this.attributes.id]).join('/')
    }

    throw new Error('Custom field value is not configured properly.')
  }

  get isInstalled(): boolean {
    return this.attributes.installed
  }
}

export default CustomFieldValue
